<template>
  <div>
    <van-cell title="程序下载">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step1.chengXuXiaZai" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="数码管指示灯显示正常">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step1.shuMaGuan" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="按键正常工作">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step1.anJian" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="hwsy01_Step1.remark"> </van-field>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step1" :disabled="$parent.hwsy01_SignNumber.status!=0" round block @click="save_HWSY01_Step1">保存</van-button>
      <van-button type="danger" v-if="$parent.hwsy01_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.hwsy01_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["signNumber"],
  data() {
    return {
      hwsy01_Step1: {},
    };
  },
  methods: {
    getHWSY01_Step1() {
      let that = this;
      that.axios
        .post("/HWSY01/GetHWSY01_Step1", { onlyText: that.signNumber })
        .then(function (response) {
          that.hwsy01_Step1 = response.data.data;
        });
    },
    save_HWSY01_Step1() {
      let that = this;
      that.axios
        .post("HWSY01/UpdateHWSY01_Step1", that.hwsy01_Step1)
        .then(function (response) {
          that.hwsy01_Step1 = response.data.data;
          that.$notify({ type: "success", message: response.data.msg });
        });
    },
  },
  mounted() {
    let that = this;
    that.getHWSY01_Step1();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
</style>